import { Observable } from 'rxjs';
import { BusinessRule, Ordering, Pagination } from '../model';
import { RuleTypes } from './business-rules.model';
export interface BusinessRulesState {
  isLoading: boolean;
  organizationId: number;
  searchTerm: string;
  ordering: Ordering;
  pagination: Pagination;
  businessRuleType: RuleTypes;
}

export interface BusinessRulesVMHandlers {
  updateSearchTerm: (criteria: string) => void;
  updatePagination: (options: Partial<Pagination>) => void;
  updateOrdering: (orderBy: string) => void;
  deleteRule: (rule: BusinessRule) => void;
  upsertRule: (
    ruleUpdates: Partial<BusinessRule>,
    rule?: BusinessRule
  ) => Observable<BusinessRule>;
}

export interface BusinessRulesViewModel
  extends BusinessRulesVMHandlers,
    BusinessRulesState {
  rules: BusinessRule[];
}

export function initState(): BusinessRulesState {
  return {
    isLoading: false,
    organizationId: undefined,
    searchTerm: '',
    ordering: {
      orderBy: 'createDate',
      isDescending: true,
    },
    pagination: {
      totalCount: 0,
      currentPage: 1,
      pageSize: 10,
      totalPages: 0,
    },
    businessRuleType: RuleTypes.BusinessRule,
  };
}
